import request from '@/utils/request'


// 查询计划反馈记录列表
export function listFeedback(query) {
  return request({
    url: '/plan/feedback/list',
    method: 'get',
    params: query
  })
}

// 查询计划反馈记录分页
export function pageFeedback(query) {
  return request({
    url: '/plan/feedback/page',
    method: 'get',
    params: query
  })
}

// 查询计划反馈记录详细
export function getFeedback(data) {
  return request({
    url: '/plan/feedback/detail',
    method: 'get',
    params: data
  })
}

// 新增计划反馈记录
export function addFeedback(data) {
  return request({
    url: '/plan/feedback/add',
    method: 'post',
    data: data
  })
}

// 修改计划反馈记录
export function updateFeedback(data) {
  return request({
    url: '/plan/feedback/edit',
    method: 'post',
    data: data
  })
}

// 删除计划反馈记录
export function delFeedback(data) {
  return request({
    url: '/plan/feedback/delete',
    method: 'post',
    data: data
  })
}
